<template>
    <el-container style="height: 100%">
        <el-header style="height: 30px">
            <van-nav-bar title="异动历史" left-text="返回" left-arrow @click-left="historyBack"/>
        </el-header>
        <el-main>
            <el-table class="date-table" :data="staffChangeData" size="mini" :border=true stripe :default-sort = "{prop: 'changedate', order: 'descending'}">
                <el-table-column  prop="changetype" label="单据类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.changetype==1">入职</span>
                        <span v-if="scope.row.changetype==2">离职</span>
                        <span v-if="scope.row.changetype==3">重回公司</span>
                        <span v-if="scope.row.changetype==4">职位调整</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="oldposname" label="原职位"></el-table-column>
                <el-table-column  prop="newposname" label="新职位"></el-table-column>
                <el-table-column  prop="changedate" label="调整日期"></el-table-column>
            </el-table>
        </el-main>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            staffChangeData:[],
            staffid:"",
        }
    },
    created() {
        this.staffid=this.$route.query.staffid;
        this.getStaffChangeByStaffId();
    },
    methods:{
        getStaffChangeByStaffId(){
            this.$post("staff/getStaffChangeByStaffId",{staffid:this.staffid}).then(res=>{
                if(res.sucess){
                    this.staffChangeData=res.object;
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/page/intebo/intebostaff/staffchangehistory.vue